module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "body",
    staticClass: "section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showImage),
      expression: "!showImage"
    }]
  }, [_c('dl', [_vm._m(0), _vm._v(" "), _vm._l((_vm.top), function(row, idx) {
    return _c('dd', [_c('div', {
      ref: idx,
      refInFor: true,
      staticClass: "container publicity",
      attrs: {
        "id": idx
      }
    }, [_c('div', {
      staticClass: "item col-md-1"
    }, [_vm._v(_vm._s(row.username))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-1 one-row"
    }, [_vm._v(_vm._s(row.school))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-1"
    }, [_vm._v(_vm._s(_vm.groups[row.gid]))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-3 one-row"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.showImageList(idx)
        }
      }
    }, [_c('u', [_vm._v(_vm._s(row.name))])])]), _vm._v(" "), (row.teacher) ? _c('div', {
      staticClass: "item col-md-2 one-row"
    }, [_vm._v(_vm._s(row.teacher))]) : _c('div', {
      staticClass: "item col-md-2"
    }, [_vm._v("无")])])])
  }), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImage),
      expression: "showImage"
    }]
  }, [_c('a', {
    on: {
      "click": _vm.backList
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("作品名称:")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.dataList.name))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("封面图:")]), _vm._v(" "), _c('img', {
    staticClass: "titleImage",
    attrs: {
      "src": _vm.titleImage,
      "alt": "",
      "oncontextmenu": "return false;",
      "ondragstart": "return false;",
      "oncopy": "return false;",
      "onselect": "return false"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "awardMsg",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("作品说明：")]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.dataList.note))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("任务书:")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.task,
      "alt": "",
      "oncontextmenu": "return false;",
      "ondragstart": "return false;",
      "oncopy": "return false;",
      "onselect": "return false"
    }
  })]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("设计图：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "id": "imageList"
    }
  }, [_c('div', {
    staticClass: "imgList"
  }, _vm._l((_vm.imgList), function(value, index) {
    return _c('div', {
      staticClass: "imgBox"
    }, [(!('http://www.archirookies.com/assets/upload/null' == _vm.imgList[index])) ? _c('img', {
      attrs: {
        "src": value,
        "oncontextmenu": "return false;",
        "ondragstart": "return false;",
        "oncopy": "return false;",
        "onselect": "return false"
      }
    }) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', [(_vm.showBigImg) ? _c('div', {
    ref: "imgMask",
    staticClass: "imgMask",
    style: (_vm.positionTop),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showBigImg = !_vm.showBigImg
      }
    }
  }, [_c('img', {
    staticClass: "prev imgPosition",
    attrs: {
      "src": require("./../../static/prev.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "showImg imgPosition",
    on: {
      "onmousewheel": function($event) {
        $event.preventDefault();
        return _vm.rollImg($event)
      }
    }
  }, [_c('img', {
    staticClass: "bigImg",
    attrs: {
      "src": _vm.imgList[_vm.num]
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "next imgPosition",
    attrs: {
      "src": require("./../../static/next.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.dataList.video) ? _c('h1', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("视频:")])]) : _vm._e(), _vm._v(" "), (_vm.dataList.video) ? _c('div', {
    staticClass: "info-img"
  }, [_c('div', {
    staticClass: "player"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('div', {
    staticClass: "container publicity"
  }, [_c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("作者")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("学校")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("年级")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-3 one-row"
  }, [_vm._v("参赛作品名")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-2"
  }, [_vm._v("指导教师")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('u', [_vm._v("\n      <<- 返回作品列表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-601cc7f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Top.vue
// module id = 620
// module chunks = 1